module.exports = __webpack_public_path__ + "static/media/google4.3b00f27b.png";